import BlainBaseService from "JS/services/BlainBaseService";
import { IListableProductJson } from "JS/types/Product";
import { ITireRecommendationRequest } from "../types/TireRecommendation.types";

export interface ITireRecommendationService {
	getRecommendations(req: ITireRecommendationRequest): Promise<IListableProductJson[]>;
	getWarrantyCodes(): Promise<Record<number, string>>;
}

export default class TireRecommendationService extends BlainBaseService implements ITireRecommendationService {

	private readonly BASE_URL = '/tire-recommendations'

	async getRecommendations(req: ITireRecommendationRequest): Promise<IListableProductJson[]> {
		return this._httpSvc.post<IListableProductJson[]>(`${this.BASE_URL}/`, req);
	}

	async getWarrantyCodes(): Promise<Record<number, string>> {
		return this._httpSvc.get(`${this.BASE_URL}/warrantycodes/`);
	}

}

// TODO: Move these types
